import { formatAmount } from '@/shared';

import type { TStatistics } from '../../store/types';

export const convertStatisticsToView = (items: TStatistics[]): TStatistics[] => {
  const sortedItems = [...items].sort((a, b) => b.totalApproved - a.totalApproved);

  const statistics: TStatistics[] = sortedItems.map((item) => ({
    ...item,
    transactionsAmount: formatAmount(item.transactionsAmount),
    remoteTransactionsAmount: formatAmount(item.remoteTransactionsAmount),
    customTransactionsAmount: formatAmount(item.customTransactionsAmount),
    activeWithdrawalsAmount: formatAmount(item.activeWithdrawalsAmount),
    approvedWithdrawalsAmount: formatAmount(item.approvedWithdrawalsAmount),
    totalBalance: formatAmount(item.totalBalance),
  }));

  return statistics;
};
